import { Card, CardBody, Chip } from "@heroui/react";
import { Icon } from "@iconify/react";
import { TRequest } from "@shared/entities";

/** Admin-only: the patient declaration the client accepted when submitting. */
export function DeclarationSummary({ request }: { request: TRequest }) {
	const declaration = request.declaration;
	if (!declaration) return null;
	return (
		<Card>
			<CardBody className="flex flex-row flex-wrap items-center gap-3 text-sm text-start">
				<Icon icon="lucide:file-check" className="text-success" width={18} />
				<span>
					הצהרת המטופל אושרה ב־
					{new Date(declaration.acceptedAt).toLocaleString("he-IL", { dateStyle: "short", timeStyle: "short" })}
				</span>
				<span className="text-default-400">נוסח {declaration.version}</span>
				<Chip size="sm" variant="flat" color={declaration.renewalContactConsent ? "success" : "default"}>
					{declaration.renewalContactConsent ? "מאשר/ת קשר לפני חידוש" : "לא אישר/ה קשר לפני חידוש"}
				</Chip>
			</CardBody>
		</Card>
	);
}
